// Generated by frontend/scripts/extract-insights.js. Do not edit.
// Imported by the lazy article page and by eduSeo.js. Article JSON stays in
// the lazy chunks: callers use loadArticle, they do not import the JSON.

export function loadArticle(exam, slug) {
  switch (exam + '/' + slug) {
    case 'lnat/study-guide':
      return import('../content/insights/lnat/study-guide.json');
    case 'lnat/good-lnat-score':
      return import('../content/insights/lnat/good-lnat-score.json');
    case 'lnat/essay-marking':
      return import('../content/insights/lnat/essay-marking.json');
    case 'lnat/prep-priority':
      return import('../content/insights/lnat/prep-priority.json');
    case 'lnat/assumption-trap':
      return import('../content/insights/lnat/assumption-trap.json');
    case 'lnat/pacing':
      return import('../content/insights/lnat/pacing.json');
    case 'lnat/interview':
      return import('../content/insights/lnat/interview.json');
    case 'lnat/mistake-review':
      return import('../content/insights/lnat/mistake-review.json');
    case 'lnat/readiness':
      return import('../content/insights/lnat/readiness.json');
    case 'lnat/ivori-method-for-lnat':
      return import('../content/insights/lnat/ivori-method-for-lnat.json');
    case 'lnat/lsat-logic':
      return import('../content/insights/lnat/lsat-logic.json');
    case 'lnat/reading-list':
      return import('../content/insights/lnat/reading-list.json');
    case 'tmua/study-guide':
      return import('../content/insights/tmua/study-guide.json');
    case 'tmua/good-tmua-score':
      return import('../content/insights/tmua/good-tmua-score.json');
    case 'tmua/paper2-marking':
      return import('../content/insights/tmua/paper2-marking.json');
    case 'tmua/prep-priority':
      return import('../content/insights/tmua/prep-priority.json');
    case 'tmua/converse-trap':
      return import('../content/insights/tmua/converse-trap.json');
    case 'tmua/pacing':
      return import('../content/insights/tmua/pacing.json');
    case 'tmua/interview':
      return import('../content/insights/tmua/interview.json');
    case 'tmua/mistake-review':
      return import('../content/insights/tmua/mistake-review.json');
    case 'tmua/readiness':
      return import('../content/insights/tmua/readiness.json');
    case 'tmua/ivori-method-for-tmua':
      return import('../content/insights/tmua/ivori-method-for-tmua.json');
    case 'tmua/necessary-sufficient':
      return import('../content/insights/tmua/necessary-sufficient.json');
    case 'tmua/past-papers':
      return import('../content/insights/tmua/past-papers.json');
    case 'tara/study-guide':
      return import('../content/insights/tara/study-guide.json');
    case 'tara/good-tara-score':
      return import('../content/insights/tara/good-tara-score.json');
    case 'tara/writing-task-marking':
      return import('../content/insights/tara/writing-task-marking.json');
    case 'tara/prep-priority':
      return import('../content/insights/tara/prep-priority.json');
    case 'tara/weaken-the-argument-trap':
      return import('../content/insights/tara/weaken-the-argument-trap.json');
    case 'tara/pacing':
      return import('../content/insights/tara/pacing.json');
    case 'tara/interview':
      return import('../content/insights/tara/interview.json');
    case 'tara/mistake-review':
      return import('../content/insights/tara/mistake-review.json');
    case 'tara/readiness':
      return import('../content/insights/tara/readiness.json');
    case 'tara/ivori-method-for-tara':
      return import('../content/insights/tara/ivori-method-for-tara.json');
    case 'tara/cognitive-reflection-test':
      return import('../content/insights/tara/cognitive-reflection-test.json');
    case 'tara/reading-list':
      return import('../content/insights/tara/reading-list.json');
    case 'ucat/study-guide':
      return import('../content/insights/ucat/study-guide.json');
    case 'ucat/good-ucat-score':
      return import('../content/insights/ucat/good-ucat-score.json');
    case 'ucat/how-ucat-is-scored':
      return import('../content/insights/ucat/how-ucat-is-scored.json');
    case 'ucat/ucat-vs-gamsat':
      return import('../content/insights/ucat/ucat-vs-gamsat.json');
    case 'ucat/sjt-scoring-trap':
      return import('../content/insights/ucat/sjt-scoring-trap.json');
    case 'ucat/pacing':
      return import('../content/insights/ucat/pacing.json');
    case 'ucat/mmi-transition':
      return import('../content/insights/ucat/mmi-transition.json');
    case 'ucat/mistake-review':
      return import('../content/insights/ucat/mistake-review.json');
    case 'ucat/readiness':
      return import('../content/insights/ucat/readiness.json');
    case 'ucat/ivori-method-for-ucat':
      return import('../content/insights/ucat/ivori-method-for-ucat.json');
    case 'ucat/logic-puzzles':
      return import('../content/insights/ucat/logic-puzzles.json');
    case 'ucat/practice-materials':
      return import('../content/insights/ucat/practice-materials.json');
    case 'esat/study-guide':
      return import('../content/insights/esat/study-guide.json');
    case 'esat/good-esat-score':
      return import('../content/insights/esat/good-esat-score.json');
    case 'esat/how-esat-is-scored':
      return import('../content/insights/esat/how-esat-is-scored.json');
    case 'esat/esat-vs-pat':
      return import('../content/insights/esat/esat-vs-pat.json');
    case 'esat/unit-conversion-trap':
      return import('../content/insights/esat/unit-conversion-trap.json');
    case 'esat/pacing':
      return import('../content/insights/esat/pacing.json');
    case 'esat/interview':
      return import('../content/insights/esat/interview.json');
    case 'esat/mistake-review':
      return import('../content/insights/esat/mistake-review.json');
    case 'esat/readiness':
      return import('../content/insights/esat/readiness.json');
    case 'esat/ivori-method-for-esat':
      return import('../content/insights/esat/ivori-method-for-esat.json');
    case 'esat/physics-olympiad':
      return import('../content/insights/esat/physics-olympiad.json');
    case 'esat/practice-materials':
      return import('../content/insights/esat/practice-materials.json');
    case 'oxbridge/study-guide':
      return import('../content/insights/oxbridge/study-guide.json');
    case 'oxbridge/pacing':
      return import('../content/insights/oxbridge/pacing.json');
    case 'oxbridge/what-interviewers-listen-for':
      return import('../content/insights/oxbridge/what-interviewers-listen-for.json');
    case 'oxbridge/right-answer-myth':
      return import('../content/insights/oxbridge/right-answer-myth.json');
    case 'oxbridge/personal-statement-interviews':
      return import('../content/insights/oxbridge/personal-statement-interviews.json');
    case 'oxbridge/thinking-aloud':
      return import('../content/insights/oxbridge/thinking-aloud.json');
    case 'oxbridge/oxford-tutorial-tradition':
      return import('../content/insights/oxbridge/oxford-tutorial-tradition.json');
    case 'oxbridge/adapting-in-real-time':
      return import('../content/insights/oxbridge/adapting-in-real-time.json');
    case 'oxbridge/mistake-review':
      return import('../content/insights/oxbridge/mistake-review.json');
    case 'oxbridge/readiness':
      return import('../content/insights/oxbridge/readiness.json');
    case 'oxbridge/reading-list':
      return import('../content/insights/oxbridge/reading-list.json');
    case 'oxbridge/ivori-method-for-oxbridge':
      return import('../content/insights/oxbridge/ivori-method-for-oxbridge.json');
    case 'medicine/study-guide':
      return import('../content/insights/medicine/study-guide.json');
    case 'medicine/mmi-vs-panel':
      return import('../content/insights/medicine/mmi-vs-panel.json');
    case 'medicine/what-examiners-listen-for':
      return import('../content/insights/medicine/what-examiners-listen-for.json');
    case 'medicine/right-answer-myth':
      return import('../content/insights/medicine/right-answer-myth.json');
    case 'medicine/panel-vs-mmi-format':
      return import('../content/insights/medicine/panel-vs-mmi-format.json');
    case 'medicine/ethical-reasoning':
      return import('../content/insights/medicine/ethical-reasoning.json');
    case 'medicine/spikes-protocol':
      return import('../content/insights/medicine/spikes-protocol.json');
    case 'medicine/professional-judgement':
      return import('../content/insights/medicine/professional-judgement.json');
    case 'medicine/mistake-review':
      return import('../content/insights/medicine/mistake-review.json');
    case 'medicine/readiness':
      return import('../content/insights/medicine/readiness.json');
    case 'medicine/reading-list':
      return import('../content/insights/medicine/reading-list.json');
    case 'medicine/ivori-method-for-medicine':
      return import('../content/insights/medicine/ivori-method-for-medicine.json');
    case 'medicine/mmi-skills':
      return import('../content/insights/medicine/mmi-skills.json');
    case 'medicine/panel-skills':
      return import('../content/insights/medicine/panel-skills.json');
    case 'medicine/prepare-for-mmi':
      return import('../content/insights/medicine/prepare-for-mmi.json');
    case 'medicine/prepare-for-panel':
      return import('../content/insights/medicine/prepare-for-panel.json');
    case 'degree-apprenticeships/study-guide':
      return import('../content/insights/degree-apprenticeships/study-guide.json');
    case 'degree-apprenticeships/pacing':
      return import('../content/insights/degree-apprenticeships/pacing.json');
    case 'degree-apprenticeships/what-assessors-listen-for':
      return import('../content/insights/degree-apprenticeships/what-assessors-listen-for.json');
    case 'degree-apprenticeships/perfect-answer-myth':
      return import('../content/insights/degree-apprenticeships/perfect-answer-myth.json');
    case 'degree-apprenticeships/group-exercise-vs-competency-interview':
      return import('../content/insights/degree-apprenticeships/group-exercise-vs-competency-interview.json');
    case 'degree-apprenticeships/structured-answers':
      return import('../content/insights/degree-apprenticeships/structured-answers.json');
    case 'degree-apprenticeships/what-group-exercises-measure':
      return import('../content/insights/degree-apprenticeships/what-group-exercises-measure.json');
    case 'degree-apprenticeships/commercial-judgement-under-pressure':
      return import('../content/insights/degree-apprenticeships/commercial-judgement-under-pressure.json');
    case 'degree-apprenticeships/mistake-review':
      return import('../content/insights/degree-apprenticeships/mistake-review.json');
    case 'degree-apprenticeships/readiness':
      return import('../content/insights/degree-apprenticeships/readiness.json');
    case 'degree-apprenticeships/commercial-reading-list':
      return import('../content/insights/degree-apprenticeships/commercial-reading-list.json');
    case 'degree-apprenticeships/ivori-method-for-degree-apprenticeships':
      return import('../content/insights/degree-apprenticeships/ivori-method-for-degree-apprenticeships.json');
    case 'general/study-guide':
      return import('../content/insights/general/study-guide.json');
    case 'general/reasoning-education':
      return import('../content/insights/general/reasoning-education.json');
    case 'general/problem-solving':
      return import('../content/insights/general/problem-solving.json');
    case 'general/stretch-and-challenge':
      return import('../content/insights/general/stretch-and-challenge.json');
    case 'general/live-interviews':
      return import('../content/insights/general/live-interviews.json');
    case 'general/drills-vs-tutoring':
      return import('../content/insights/general/drills-vs-tutoring.json');
    case 'general/parents-guide':
      return import('../content/insights/general/parents-guide.json');
    default:
      return Promise.reject(new Error('missing article'));
  }
}
